import { ALIGN_CLASSES_INVERSE as h, MENTION_CLASS as c, NO_MARGIN_CLASS as d } from "./constants.js";
import { decodeAttributes as m } from "./utils/attribute-encoding.js";
import { BlockListParser as p, DocumentHtmlEntityDecoder as u } from "@intercom/interblocks.ts";
class b {
  constructor(e, i) {
    this.documentBuilder = e, this.config = i;
    const t = e.schema;
    this.markMap = {
      b: t.marks.bold,
      i: t.marks.italic,
      a: t.marks.anchor,
      code: t.marks.code,
      u: t.marks.underline,
      span: t.marks.span
    }, this.nodeMap = {
      p: t.nodes.paragraph,
      ol: t.nodes.orderedList,
      ul: t.nodes.unorderedList,
      li: t.nodes.listItem,
      h1: t.nodes.heading,
      h2: t.nodes.subheading,
      h3: t.nodes.subheading3,
      h4: t.nodes.subheading4,
      small: t.nodes.small,
      pre: t.nodes.codeBlock,
      br: t.nodes.hardBreak,
      hr: t.nodes.horizontalLine,
      template: t.nodes.template,
      mention: t.nodes.mention,
      aiPromptData: t.nodes.aiPromptData,
      img: t.nodes.inlineImage
    };
  }
  blockAttrs;
  markMap;
  nodeMap;
  marks = ["b", "i", "a", "code", "u", "span"];
  nodes = ["p", "br", "ol", "ul", "li", "h1", "h2", "h3", "h4", "small", "pre", "img"];
  handle(e, i) {
    p.parse(
      [e],
      new u(document),
      !!this.nodeMap.template,
      this.config.isPlaintext,
      !0,
      !1,
      !1
    ).body.forEach((a) => this.handleNode(a, i));
  }
  handleNode(e, i) {
    if (e.isElement)
      if (this.isMention(e))
        this.mention(e);
      else if (this.isAiPromptData(e))
        this.aiPromptData(e);
      else if (this.marks.includes(e.value ?? ""))
        this.mark(e);
      else if (this.nodes.includes(e.value ?? ""))
        this.node(e, i);
      else
        throw new Error(`unknown element type: ${e.value}`);
    else e.isLiteral ? this.documentBuilder.addText(e.value ?? "") : e.type === "Template" ? this.template(e) : (this.stashBlockAttrs(e), this.handleChildren(e.children ?? [], i));
  }
  node(e, i) {
    const t = this.nodeMap[e.value ?? ""];
    if (!t)
      return;
    const a = this.collectAttrs(e), n = this.consumeBlockAttrs();
    if (this.addAlignment(a, n), this.addStyle(a), t === this.nodeMap.img) {
      const r = e.attributes?.find((s) => s.name === "alt");
      r && (a.text = r.value);
      const l = e.attributes?.find((s) => s.name === "data-class-name");
      l && (a.className = l.value);
    }
    if (this.documentBuilder.openNode(t, a), t === this.nodeMap.li) {
      const r = this.nodeMap.p;
      this.documentBuilder.openNode(r, {});
    }
    this.handleChildren(e.children ?? [], i), t === this.nodeMap.li && this.documentBuilder.closeNode(), this.documentBuilder.closeNode(), this.addExtraParagraphIfLegacyParagraph(e, n, i);
  }
  mark(e) {
    const i = this.markMap[e.value ?? ""];
    let t;
    i && this.documentBuilder.top().type.allowsMarkType(i) && (t = i.create(this.collectAttrs(e)), this.documentBuilder.openMark(t), i === this.markMap.a && this.handleInlineImageLinkUrl(t, e)), this.handleChildren(e.children ?? []), t && this.documentBuilder.closeMark(t);
  }
  mention(e) {
    const i = this.collectAttrs(e);
    this.nodeMap.mention && (this.documentBuilder.openNode(this.nodeMap.mention, {
      name: e.children?.[0]?.value ?? "",
      uri: i.href
    }), this.documentBuilder.closeNode());
  }
  aiPromptData(e) {
    let i = this.collectAttrs(e);
    const t = {};
    for (const [a, n] of Object.entries(i))
      if (typeof a == "string" && a.startsWith("data-prompt-data-")) {
        const l = a.split("-").slice(3).map((s, o) => o === 0 ? s : s.charAt(0).toUpperCase() + s.slice(1)).join("");
        t[l] = String(n);
      }
    i = t, this.nodeMap.aiPromptData && (this.documentBuilder.openNode(this.nodeMap.aiPromptData, i), this.documentBuilder.closeNode());
  }
  template(e) {
    this.nodeMap.template && (this.documentBuilder.openNode(this.nodeMap.template, {
      attributePath: e.value ?? "",
      fallback: e.fallback ?? ""
    }), this.documentBuilder.closeNode());
  }
  handleInlineImageLinkUrl(e, i) {
    if (i.children?.length === 1 && i.children[0]?.value === "img") {
      const t = e.attrs.href ?? "";
      i.children[0].attributes?.push({
        type: "Attribute",
        name: "linkUrl",
        value: t
      });
    }
  }
  collectAttrs(e) {
    const i = {};
    return e.attributes?.forEach((t) => {
      const a = m(t.value);
      i[t.name] ? i[t.name] += ` ${a}` : i[t.name] = a;
    }), e.type === "Block" && (i.type = e.value), e.isElement && e.id && (i.idAttribute = e.id), i;
  }
  stashBlockAttrs(e) {
    this.blockAttrs = this.collectAttrs(e);
  }
  consumeBlockAttrs() {
    const e = this.blockAttrs;
    return this.blockAttrs = void 0, e;
  }
  addAlignment(e, i) {
    !i || typeof i.class != "string" || i.class.split(" ").forEach((t) => {
      const a = h[t];
      a && Object.assign(e, { alignment: a });
    });
  }
  addStyle(e) {
    !e || typeof e.style != "string" || e.style.split(";").forEach((i) => {
      if (!i)
        return;
      const t = i.split(":", 2), a = t[0], n = t[1].trim();
      a === "font-family" && Object.assign(e, { fontFamily: n }), a === "color" && Object.assign(e, { fontColor: n }), a === "width" && Object.assign(e, { width: n.replace("px", "") });
    });
  }
  handleChildren(e, i) {
    e.forEach((t) => {
      this.handleNode(t, i);
    });
  }
  isMention(e) {
    return !!(this.nodeMap.mention && e.value === "a" && e.attributes?.find((i) => i.name === "class" && i.value === c));
  }
  isAiPromptData(e) {
    return !!(this.nodeMap.aiPromptData && e.value === "span" && e.attributes?.find((i) => i.name === "data-ai-prompt-data"));
  }
  addExtraParagraphIfLegacyParagraph(e, i, t) {
    this.isParagraphWithImplicitMargin(e, i, t) && !this.config.singleBlockMode && !this.config.allowImplicitMarginParagraphs && (this.documentBuilder.openNode(this.nodeMap.p, {}), this.documentBuilder.closeNode());
  }
  isParagraphWithImplicitMargin(e, i, t) {
    return !i || !t ? !1 : e.value === "p" && !i.class.includes(d);
  }
}
export {
  b as TextBlockParser
};
